import { IApiLink, Guid } from "@/types"
import { ApiLinkEntity, ApiLinkRel, ArticleType } from "config/constants"

export interface IArticleShortDTO {
    id:	Guid
    articleNo: string
    manufacturerDescription: string
    manufacturerArticleNo: string
    description: string
    articleType: ArticleType
    articleTypeDescription?: string
    thumbnailUri?: string
    imageUri?: string
    links: IApiLink[]
}

export interface IArticleShort {
    id:	string
    articleNo: string
    manufacturerDescription: string
    manufacturerArticleNo: string
    description: string
    articleType: ArticleType
    articleTypeDescription?: string
    thumbnailUri?: string
    imageUri?: string
    getArticleLink?: IApiLink
}

export class ArticleShort implements IArticleShort {
    id:	string
    articleNo: string
    manufacturerDescription: string
    manufacturerArticleNo: string
    description: string
    articleType: ArticleType
    articleTypeDescription?: string
    thumbnailUri?: string
    imageUri?: string
    getArticleLink?: IApiLink

    constructor({
        id,
        articleNo,
        manufacturerDescription,
        manufacturerArticleNo,
        description,
        getArticleLink,
        articleType,
        articleTypeDescription,
        thumbnailUri,
        imageUri
    }: IArticleShort) {
        this.id = id
        this.articleNo = articleNo
        this.manufacturerDescription = manufacturerDescription
        this.manufacturerArticleNo = manufacturerArticleNo
        this.description = description
        this.articleType = articleType
        this.articleTypeDescription = articleTypeDescription
        this.thumbnailUri = thumbnailUri
        this.imageUri = imageUri
        this.getArticleLink = getArticleLink
    }

    static fromDTO(dto: IArticleShortDTO): ArticleShort {
        const getArticleLink = dto.links.find(link => link.entity === ApiLinkEntity.article && link.rel === ApiLinkRel.self)
        return new ArticleShort({
            id: dto.id,
            articleNo: dto.articleNo,
            manufacturerDescription: dto.manufacturerDescription,
            manufacturerArticleNo: dto.manufacturerArticleNo,
            description: dto.description,
            articleType: dto.articleType,
            articleTypeDescription: dto.articleTypeDescription,
            thumbnailUri: dto.thumbnailUri,
            imageUri: dto.imageUri,
            getArticleLink
        })
    }
}
